"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.function.name.js");
var _react = _interopRequireDefault(require("react"));
var _FormControls = require("../FormControls");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = _interopRequireDefault(require("lodash"));
var _utils = require("../../../../common/utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var InlineNumberField = function InlineNumberField(props) {
  var displayError = props.displayError,
    name = props.name,
    label = props.label,
    _handleChange = props.handleChange,
    paddedError = props.paddedError,
    _handleBlur = props.handleBlur,
    value = props.value,
    errorMessages = props.errorMessages,
    id = props.id,
    title = props.title,
    maxLength = props.maxLength,
    disabled = props.disabled;
  return /*#__PURE__*/_react.default.createElement(_FormControls.TextBoxField, {
    value: value,
    label: label,
    id: id,
    title: title,
    name: name,
    maxLength: maxLength,
    paddedError: paddedError,
    type: "text",
    handleChange: function handleChange(e) {
      var targetVal = e.target.value;
      var value = (0, _utils.checkIfValuesAre)([null, '', undefined], targetVal) ? '' : _lodash.default.toNumber(targetVal);
      if (!_lodash.default.isNaN(value)) {
        _handleChange(e.target.name, value);
      }
    },
    handleBlur: function handleBlur() {
      return _handleBlur(name);
    },
    errorMessages: errorMessages,
    displayError: displayError,
    disabled: disabled
  });
};
InlineNumberField.propTypes = {
  /** For the input */
  label: _propTypes.default.string,
  optional: _propTypes.default.bool,
  value: _propTypes.default.any,
  disabled: _propTypes.default.bool,
  /* Error */
  displayError: _propTypes.default.bool,
  errorMessages: _propTypes.default.any,
  /** Functions */
  handleChange: _propTypes.default.func.isRequired,
  handleBlur: _propTypes.default.func
};
var _default = InlineNumberField;
exports.default = _default;